import TeamInformation from './teamInformation';
import './leftBodyCard.sass';

/**
 * Componente que representa la parte izquierda del cuerpo de una tarjeta,
 * mostrando la información de los equipos o jugadores (nombre e imagen).
 */
export default function LeftBodyCardGlobal({ data }) {
  const { left_short_name, left_image, left_name, right_image, right_short_name, right_name } = data;

  /**
   * Retorna el nombre corto si está disponible y no es vacío,
   * de lo contrario, retorna el nombre completo.
   */
  const getDisplayName = (shortName, fullName) =>
    shortName?.trim()?.length > 0 ? shortName : fullName;

  return (
    <div className="body-card-global__left">
      <TeamInformation
        image={left_image}
        alt={left_name}
        name={getDisplayName(left_short_name, left_name)}
        className="body-card-global__left-team-left"
      />

      <TeamInformation
        image={right_image}
        alt={right_name}
        name={getDisplayName(right_short_name, right_name)}
        className="body-card-global__left-team-right"
      />
    </div>
  );
}